const formatPrice = (price, currency) => {
  if (price && currency) {
    return `${currency} ${parseFloat(price).toFixed(2)}`;
  }
  return null;
};

export const capitalizeFirstLetters = string =>
  string
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');

export default formatPrice;
